import { TEmblaOptions } from "@housebets/housebets-x-package";

export const EMBLA_OPTIONS: TEmblaOptions = {
    align: 'start',
    slidesPerView: 'auto',
    mobileSlidesPerView: 'auto',
    slideSpacing: '11px',
    dragFree: true,
    offset: '0rem',
    fade: false,
    autoplay: false,
};